import type { AuthUserType } from '../types';
import { Permissions } from './permissions';

const RolePermissions: Record<AuthUserType, Permissions[]> = {
    Root: [
        Permissions.DASHBOARD,

        Permissions.SALES_TRANSACTION_CREATE,
        Permissions.SALES_TRANSACTION_UPDATE,
        Permissions.SALES_TRANSACTION_VIEW_DETAIL,
        Permissions.SALES_TRANSACTION_VIEW_ALL_TRANSACTIONS,
        Permissions.SALES_TRANSACTION_CANCEL,
        Permissions.SALES_TRANSACTION_EXPORT,
        Permissions.SALES_TRANSACTION_UPDATE_TARGET_HANDOVER_DATE,
        Permissions.SALES_TRANSACTION_FILTER_TARGET_HANDOVER_DATE,

        Permissions.VEHICLE_UPDATE_INFO,
        Permissions.VEHICLE_ADD_DIAGRAM_COMMENT,

        Permissions.OFFER_CREATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_PERIOD,
        Permissions.OFFER_END_OFFER_SESSION,
        Permissions.OFFER_VIEW_TOP_BIDS,
        Permissions.OFFER_VIEW_TOP_OFFER_AMOUNTS,
        Permissions.OFFER_VIEW_PAST_BIDS,
        Permissions.OFFER_UPDATE_HANDLING_CHARGES_AND_MARGIN,
        Permissions.OFFER_UPDATE_AWARDED_OFFER,

        Permissions.USER_ACCOUNT_APPROVAL,
        Permissions.USER_ACCOUNT_LIST,
        Permissions.USER_ACCOUNT_UPDATE,
        Permissions.USER_ACCOUNT_GET_DETAIL,
        Permissions.USER_ACCOUNT_UPDATE_STATUS,

        Permissions.NOTIFICATION_LOG_LIST,
        Permissions.ACTIVITIES_LOG_EXPORT,

        Permissions.USER_PROFILE_VIEW_DATABASE_ID,
        Permissions.USER_PROFILE_UPDATE_INFO,

        Permissions.SETTINGS_UPDATE_COMPANY_SETTINGS,
        Permissions.SETTINGS_UPDATE_TEMPLATE_USE_CASES,
    ],

    Admin: [
        Permissions.DASHBOARD,

        Permissions.SALES_TRANSACTION_CREATE,
        Permissions.SALES_TRANSACTION_UPDATE,
        Permissions.SALES_TRANSACTION_VIEW_DETAIL,
        Permissions.SALES_TRANSACTION_VIEW_ALL_TRANSACTIONS,
        Permissions.SALES_TRANSACTION_CANCEL,
        Permissions.SALES_TRANSACTION_EXPORT,
        Permissions.SALES_TRANSACTION_UPDATE_TARGET_HANDOVER_DATE,
        Permissions.SALES_TRANSACTION_FILTER_TARGET_HANDOVER_DATE,

        Permissions.VEHICLE_UPDATE_INFO,
        Permissions.VEHICLE_ADD_DIAGRAM_COMMENT,

        Permissions.OFFER_CREATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_PERIOD,
        Permissions.OFFER_END_OFFER_SESSION,
        Permissions.OFFER_VIEW_TOP_BIDS,
        Permissions.OFFER_VIEW_TOP_OFFER_AMOUNTS,
        Permissions.OFFER_VIEW_PAST_BIDS,
        Permissions.OFFER_UPDATE_HANDLING_CHARGES_AND_MARGIN,
        Permissions.OFFER_UPDATE_AWARDED_OFFER,

        Permissions.USER_ACCOUNT_APPROVAL,
        Permissions.USER_ACCOUNT_LIST,
        Permissions.USER_ACCOUNT_UPDATE,
        Permissions.USER_ACCOUNT_GET_DETAIL,
        Permissions.USER_ACCOUNT_UPDATE_STATUS,

        Permissions.NOTIFICATION_LOG_LIST,
        Permissions.ACTIVITIES_LOG_EXPORT,

        Permissions.USER_PROFILE_VIEW_DATABASE_ID,
        Permissions.USER_PROFILE_UPDATE_INFO,

        Permissions.SETTINGS_UPDATE_COMPANY_SETTINGS,
    ],

    Purchaser: [
        Permissions.DASHBOARD,

        Permissions.SALES_TRANSACTION_CREATE,
        Permissions.SALES_TRANSACTION_UPDATE,
        Permissions.SALES_TRANSACTION_VIEW_DETAIL,
        Permissions.SALES_TRANSACTION_VIEW_ALL_TRANSACTIONS,
        Permissions.SALES_TRANSACTION_CANCEL,
        Permissions.SALES_TRANSACTION_EXPORT,

        Permissions.VEHICLE_UPDATE_INFO,
        Permissions.VEHICLE_ADD_DIAGRAM_COMMENT,

        Permissions.OFFER_CREATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_PERIOD,
        Permissions.OFFER_END_OFFER_SESSION,
        Permissions.OFFER_VIEW_TOP_BIDS,
        Permissions.OFFER_VIEW_TOP_OFFER_AMOUNTS,
        Permissions.OFFER_VIEW_PAST_BIDS,
        Permissions.OFFER_UPDATE_HANDLING_CHARGES_AND_MARGIN,
        Permissions.OFFER_UPDATE_AWARDED_OFFER,

        Permissions.USER_PROFILE_UPDATE_INFO,

        Permissions.NOTIFICATION_LOG_LIST,
        Permissions.ACTIVITIES_LOG_EXPORT,
    ],

    SalesManager: [
        Permissions.DASHBOARD,

        Permissions.SALES_TRANSACTION_CREATE,
        Permissions.SALES_TRANSACTION_UPDATE,
        Permissions.SALES_TRANSACTION_VIEW_DETAIL,
        Permissions.SALES_TRANSACTION_VIEW_ALL_TRANSACTIONS,
        Permissions.SALES_TRANSACTION_CANCEL,
        Permissions.SALES_TRANSACTION_EXPORT,

        Permissions.VEHICLE_UPDATE_INFO,
        Permissions.VEHICLE_ADD_DIAGRAM_COMMENT,

        Permissions.OFFER_CREATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_PERIOD,
        Permissions.OFFER_END_OFFER_SESSION,
        Permissions.OFFER_VIEW_TOP_BIDS,
        Permissions.OFFER_VIEW_TOP_OFFER_AMOUNTS,
        Permissions.OFFER_VIEW_PAST_BIDS,
        Permissions.OFFER_UPDATE_HANDLING_CHARGES_AND_MARGIN,
        Permissions.OFFER_UPDATE_AWARDED_OFFER,

        Permissions.USER_ACCOUNT_APPROVAL,
        Permissions.USER_ACCOUNT_LIST,
        Permissions.USER_ACCOUNT_UPDATE,
        Permissions.USER_ACCOUNT_UPDATE_STATUS,

        Permissions.USER_PROFILE_UPDATE_INFO,

        Permissions.NOTIFICATION_LOG_LIST,
        Permissions.ACTIVITIES_LOG_EXPORT,
    ],

    SaleConsultant: [
        Permissions.SALES_TRANSACTION_CREATE,
        Permissions.SALES_TRANSACTION_UPDATE,
        Permissions.SALES_TRANSACTION_UPDATE_TARGET_HANDOVER_DATE,
        Permissions.SALES_TRANSACTION_VIEW_MY_TRANSACTIONS,
        Permissions.SALES_TRANSACTION_VIEW_DETAIL,
        Permissions.SALES_TRANSACTION_CANCEL,

        Permissions.VEHICLE_UPDATE_INFO,
        Permissions.VEHICLE_ADD_DIAGRAM_COMMENT,

        Permissions.OFFER_CREATE_OFFER_SESSION,
        Permissions.OFFER_UPDATE_OFFER_SESSION,
        Permissions.OFFER_END_OFFER_SESSION,
        Permissions.OFFER_VIEW_TOP_BIDS,
        Permissions.OFFER_VIEW_PAST_BIDS,
    ],

    Dealer: [
        Permissions.SALES_TRANSACTION_VIEW_CURRENT_TRANSACTIONS,
        Permissions.SALES_TRANSACTION_VIEW_MY_OFFERS,

        Permissions.OFFER_SUBMIT_BID,
        Permissions.OFFER_BIDDING_LIVE_DURATION,
    ],
};

export default RolePermissions;
